module.exports = __webpack_public_path__ + "img/SueloMuyAbundante.16bea16c.jpg";